import type { IconData } from '@stacksjs/iconify-core'

export const navigationArrowOffRemix: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M3.914 1.086a2 2 0 1 0-2.828 2.828l43 43a2 2 0 1 0 2.828-2.828l-10.009-10.01c3.484-8.237 7.007-18.985 8.063-27.298a3.788 3.788 0 0 0-4.249-4.247c-8.315 1.055-19.068 4.57-27.312 8.047zm20.18 20.179l2.12 2.121L40.269 9.35a1.5 1.5 0 0 0-2.12-2.123zm-14.088-7.103a2 2 0 0 1-.777 2.72l-3.302 1.833l14.24 7.798a2 2 0 0 1 .792.792l7.81 14.228l1.839-3.303a2 2 0 0 1 3.494 1.946l-2.25 4.042q-.03.053-.063.104c-.758 1.187-2.029 1.758-3.296 1.64c-1.228-.113-2.325-.853-2.94-1.974l-7.82-14.247l-14.263-7.81c-1.121-.615-1.863-1.71-1.977-2.94c-.118-1.27.455-2.54 1.643-3.296q.05-.033.103-.062l4.047-2.249a2 2 0 0 1 2.72.777\" clip-rule=\"evenodd\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default navigationArrowOffRemix
